export default __webpack_public_path__ + "static/media/card_bg_4.41332be0.png";